var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Vertrag erstellen","action":"create","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('create-form',{attrs:{"contract":_vm.contract,"expert-product":_vm.expertProduct,"setup-expert-product":_vm.setupExpertProduct,"basic-product":_vm.basicProduct,"setup-basic-product":_vm.setupBasicProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }